// design v3

export type TestCaseTItemCore = {
  /**
   * generally is expected to be a **UUID**, but in a special case\
   * of a root dir item for FE it will be **an empty string**
   */
  id: string;
  title: string;
};

//# region Payload

export type TestCaseTItemLeaf = TestCaseTItemCore & {
  type: "payload";
  goal: string;
  data?: Record<string, unknown>;
};
export type TestCaseTItemLeafRtrnFromCreate = Omit<TestCaseTItemLeaf, "goal" | "data"> &
  Required<Pick<TestCaseTItemLeaf, "goal" | "data">>;
export type TestCaseTItemLeafFull = TestCaseTItemLeafRtrnFromCreate;
export type TestCaseTItemLeafInput = Omit<TestCaseTItemLeafRtrnFromCreate, "id"> & {
  id?: string;
  parent?: string;
};

//# endregion

//# region Folder

export type TestCaseTItemDir = TestCaseTItemCore & {
  type: "folder";
  children: Array<TestCaseTItemLeaf | TestCaseTItemDir>;
};
export type TestCaseTItemDirRtrnFromCreate = TestCaseTItemDir;
export type TestCaseTItemDirInput = Omit<TestCaseTItemDir, "children" | "id"> & {
  id?: string;
  parent?: string;
};

//# endregion

export type TestCaseTItem = TestCaseTItemLeaf | TestCaseTItemDir;
export type ReleasePayloads = TestCaseTItem[];

export type TestCaseTItemInput = TestCaseTItemLeafInput | TestCaseTItemDirInput;

/**
 * very special placeholder item, we need it to derive "some" value\
 * for sortable tree data node when we are rendering a tree that is\
 * "kinda" wrapped in a root node (but that's a bit untrue as tree\
 * root data type in context is an array)
 */
export const rootTestCaseTItem: TestCaseTItemDir = {
  title: "Default folder",
  id: "",
  type: "folder",
  children: [],
};
